import { useTranslation } from 'react-i18next'

// Cancel + submit footer for the system modals; submit is disabled while saving
const FormFooter = ({ onClose, saving, submitLabel, danger = false, disabled = false }) => {
  const { t } = useTranslation()
  return (
    <>
      <button
        type='button'
        onClick={onClose}
        className='px-4 py-2 rounded bg-gray-100 text-greenPrimary hover:bg-gray-200'
      >
        {t('common.cancel')}
      </button>
      <button
        type='submit'
        disabled={saving || disabled}
        className={`px-4 py-2 rounded text-white hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed ${danger ? 'bg-red-500' : 'bg-greenPrimary'}`}
      >
        {saving ? t('common.loading') : (submitLabel || t('common.save'))}
      </button>
    </>
  )
}

export default FormFooter
